module.exports = __webpack_public_path__ + "img/testimonial-roche.9925bf57.png";